import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

combineTokens("--i-ark--print", {
  pageWidth: units.px(595),
  pageHeight: units.px(842),
  pageAspectRatio: 842 / 595
});
const generatePrintCss = orientation => `
@media print {
  body {
    -webkit-print-color-adjust: exact !important;
  }

  @page {
    margin: 0;
    size: A4 ${orientation};
  }

  div[data-print-wrapper] {
    display: block;
  }
}
`;
const printContainer = "_086p1wxepvq";
const item = "_086i5hy421";

export { generatePrintCss, item, printContainer };
import "./_print.root.style.linaria.module.css";
//# sourceMappingURL=_print.root.style.js.map
